// components/card.tsx
import React from "react";

export const Card: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
            {children}
        </div>
    );
};

export const CardHeader: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return <div className="flex flex-col space-y-1.5 p-6">{children}</div>;
};

export const CardTitle: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return (
        <h3 className="text-2xl font-semibold leading-none tracking-tight">
            {children}
        </h3>
    );
};

export const CardDescription: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return <p className="text-sm text-muted-foreground">{children}</p>;
};

export const CardContent: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    return <div className="p-6 pt-0">{children}</div>;
};
